(function () {
  'use strict';

  angular
    .module('missingSignIn')
    .config(config);

  function config($stateProvider) {
    $stateProvider
      .state('missingSignIn', {
        url: '/missing-sign-in',
        views:{
        	'missingSignInView':{
        		templateUrl: 'missing-sign-in/views/missing-sign-in.tpl.html',
        		controller: 'MissingSignInCtrl',
        		controllerAs: 'missingSignIn'
        	}
        }
      });
  }
}());
